import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  DocumentFieldDeletePayload,
  DocumentFieldsCRUDMeta,
} from 'Interfaces/DocumentFields';
import { rootActions } from 'Store';

export interface DeleteEmbedDocumentField {
  (payload: DocumentFieldDeletePayload, meta?: DocumentFieldsCRUDMeta): void;
}

export default () => {
  const dispatch = useDispatch();

  const deleteEmbedDocumentField: DeleteEmbedDocumentField = useCallback(
    (
      payload: DocumentFieldDeletePayload,
      meta: DocumentFieldsCRUDMeta = { pushToHistory: true },
    ) => {
      dispatch(
        rootActions.documentField.deleteEmbedDocumentField.request({
          payload,
          meta,
        }),
      );
    },
    [dispatch],
  );

  return deleteEmbedDocumentField;
};
